import { CaptionLabelProps } from 'react-day-picker';

export const CustomCaptionLabel: React.FC<CaptionLabelProps> = ({
  ...props
}) => {
  // eslint-disable-next-line react/prop-types
  const { children } = props;
  const month = children?.toString().split(' ')[0];
  const capitalizedMonth = month
    ? month.charAt(0).toUpperCase() + month.slice(1)
    : '';
  return <span className={'rdp-caption_label'}>{capitalizedMonth}</span>;
};
